import React from 'react'
import injectSheet from 'react-jss'
import styles from './archived-files-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import ArchivedFilesEntry from './archived-files-entry/archived-files-entry.container'

const ArchivedFilesTable = ({ classes, archivedFiles }) => (
  <Table>
    <thead>
      <tr>
        <HeadCell className={classes.left}>Thumb</HeadCell>
        <HeadCell className={classes.left}>Date</HeadCell>
        <HeadCell className={classes.titleCell}>Title</HeadCell>
        <HeadCell className={classes.left}>Student</HeadCell>
        <HeadCell className={classes.left}>Age group</HeadCell>
        <HeadCell className={classes.center}>Conclusion</HeadCell>
      </tr>
    </thead>
    <tbody>
      {archivedFiles.map(archivedFile => (
        <ArchivedFilesEntry key={archivedFile.id} id={archivedFile.id} />
      ))}
    </tbody>
  </Table>
)

export default injectSheet(styles)(ArchivedFilesTable)
